import { ErrorMessage } from "@hookform/error-message";
import React, { useState } from "react";
import { ButtonGroup, Col, Form, Row, ToggleButton } from "react-bootstrap";
import { ValidationMessage } from "../../../../utils/constants/validationMessage";
import { integerInput, whiteSpaceCheck } from "../../../../helper/helper";
import PhoneInputField from "../../../../components/shared/FormFields/PhoneInputField";
import { regex } from "../../../../utils/constants/regexVariables";
// import { ValidationMessage } from "../../utils/constants/validationMessage";
// import { integerInput, whiteSpaceCheck } from "../../helper/helper";

const ProfessionalDetails = ({
  register,
  errors,
  setValue,
  setOfficePhone,
  officePhone,
  setSelectedValue,
  selectedValue,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const radios = [
    { name: "Working", value: "working" },
    { name: "Not Working", value: "not-working" },
  ];

  console.log("selectedValue", selectedValue, "curr", currentIndex);
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Office Information</span>
      <Row className="mb-3 gx-sm-3 gx-2">
        <div className="mt-4 text-center">
          <ButtonGroup toggle className="mt-3">
            {radios.map((radio, idx) => (
              <ToggleButton
                key={idx}
                id={`radio-${idx}`}
                type="radio"
                variant={radio.value === "working" ? "success" : "danger"}
                name="status"
                value={radio.value}
                checked={selectedValue === radio.value}
                onChange={(e) => {
                  setCurrentIndex(idx);
                  setSelectedValue(e.currentTarget.value);
                }}
                className="mx-2"
                style={
                  currentIndex == idx
                    ? {
                        background: "#ff6004",
                        borderColor: "#ff6004",
                        border: "1px solid #ff6004",
                      }
                    : {
                        background: "transparent",
                        color: "#ff6004",
                        borderColor: "#ff6004", // Fixed spelling error here
                        border: "1px solid #ff6004",
                      }
                }
              >
                {radio.name}
              </ToggleButton>
            ))}
          </ButtonGroup>
          <div className="mt-4">
            <p>
              Selected Status:{" "}
              <strong>
                {selectedValue === "working" ? "Working" : "Not Working"}
              </strong>
            </p>
          </div>
        </div>
      </Row>
      {currentIndex == 0 && (
        <Row className="mb-3 gx-sm-3 gx-2">
          <Col xl={4} md={4} sm={6} className="mb-3">
            <Form.Group controlId="formSurname">
              <Form.Label>
                Office Name
                <span className="text-danger">
                  <span className="text-danger">*</span>
                </span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter office"
                name="officeName"
                {...register("officeName", {
                  required: ValidationMessage.OFFICE_NAME_REQUIRED,
                  validate: (value) => whiteSpaceCheck(value),
                })}
              />
              <ErrorMessage
                errors={errors}
                name="officeName"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>
          </Col>
          <Col xl={4} md={4} sm={6} className="mb-3">
            <Form.Group controlId="formSurname">
              <Form.Label>
                Department <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter department"
                name="officeDepartmentName"
                {...register("officeDepartmentName", {
                  required: ValidationMessage.DEPARTMENT_NAME_REQUIRED,
                  validate: (value) => whiteSpaceCheck(value),
                })}
              />
              <ErrorMessage
                errors={errors}
                name="officeDepartmentName"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>
          </Col>
          <Col xl={4} md={4} sm={6} className="mb-3">
            <Form.Group controlId="formSurname">
              <Form.Label>Designation *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter designation"
                name="officeDesignationName"
                {...register("officeDesignationName", {
                  required: ValidationMessage.DESIGNATION_NAME_REQUIRED,
                  validate: (value) => whiteSpaceCheck(value),
                })}
              />
              <ErrorMessage
                errors={errors}
                name="officeDesignationName"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>
          </Col>
          <Col xl={4} md={4} sm={6} className="mb-3">
            <Form.Group controlId="formSurname">
              <Form.Label>Office Address *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter office address"
                name="officeAddress"
                {...register("officeAddress", {
                  required: ValidationMessage.ADDRESS_REQUIRED,
                  validate: (value) => whiteSpaceCheck(value),
                })}
              />
              <ErrorMessage
                errors={errors}
                name="officeAddress"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>
          </Col>

          <Col xl={4} md={4} sm={6} className="mb-3">
            <Form.Group className="" controlId="formEmail">
              <Form.Label>
                Office mobile no <span className="text-danger">*</span>
              </Form.Label>
              <PhoneInputField
                register={register}
                setValue={setValue}
                errors={errors}
                name="officePhoneNumber"
                validationMessage={ValidationMessage}
                regex={regex}
                countryCode="+91"
                initialPhone=""
                setPhone={setOfficePhone}
                phone={officePhone}
                className={""}
              />
              <ErrorMessage
                errors={errors}
                name="officePhoneNumber"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>
          </Col>

          <Col xl={4} md={4} sm={6} className="mb-3">
            <Form.Group className="" controlId="formEmail">
              <Form.Label>Tel number(s):</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter tel number(s)"
                name="officeNumber"
                {...register("officeNumber", {
                  required: false,
                })}
                onKeyPress={(e) => integerInput(e)}
              />
            </Form.Group>
          </Col>

          <Col xl={4} md={4} sm={6} className="mb-3">
            <Form.Group controlId="formSurname">
              <Form.Label>Annual Income</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter description"
                name="annualIncome"
                {...register("annualIncome", {
                  required: ValidationMessage.ANNUAL_INCOME_REQUIRED,
                  validate: (value) => whiteSpaceCheck(value),
                })}
                onKeyPress={(e) => integerInput(e)}
                maxLength={10}
              />
              <ErrorMessage
                errors={errors}
                name="annualIncome"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>
          </Col>
          <Col xl={6} md={4} sm={6} className="mb-3">
            <Form.Group controlId="formSurname">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter your description."
                name="description"
                {...register("description", {
                  required: ValidationMessage.DESCRIPTION_REQUIRED,
                  validate: (value) => whiteSpaceCheck(value),
                })}
                style={{ resize: "none" }}
              />
              <ErrorMessage
                errors={errors}
                name="description"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default ProfessionalDetails;
